// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import PestControlPage from "../pages/PestControl/PestControl";
const __wvcRoutePaths = ["/PestControlPage", "/pest-control"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "all-services", "carpet-cleaning", "carpetupholsterycleaningpage", "exterior-care", "exteriorsurfacecleaningpage", "free-quote", "getafreequotepage", "gutter-cleaning", "guttercleaningpage", "home", "homepage", "house-washing", "housewashingpage", "pest-control", "pestcontrolpage", "post", "roof-care", "roofcleaningpaintingpage", "search", "servicespage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<PestControlPage />} />
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<PestControlPage />} />
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
